// src/productData.js


const products = [
  {
    id: 1,
    name: 'Spark Plug Housing',
    description: 'High-quality housing designed for automotive spark plugs, ensuring optimal performance and longevity in high-temperature environments.',
    image: require('./assets/spark plug housing.jpg'),
  },
  {
    id: 2,
    name: 'Sensor Housing',
    description: 'Precision-machined sensor housing that provides robust protection for various types of sensors in automotive and industrial applications.',
    image: require('./assets/sensor-housings-.jpg'),
  },
  {
    id: 3,
    name: 'Cable Housing',
    description: 'Durable cable housing that ensures secure and efficient cable management, ideal for harsh industrial environments.',
    image: require('./assets/cable.jpg'),
  },
  {
    id: 5,
    name: 'Knurled Shafts',
    description: 'Precision knurled shafts designed for improved grip and anti-slip functionality in various industrial applications.',
    image: require('./assets/knurl.avif'),
  },
  {
    id: 6,
    name: 'Hydraulic Hose Connectors',
    description: 'Robust hydraulic hose connectors built to withstand high-pressure applications, ensuring leak-free connections.',
    image: require('./assets/hhh.jpg'),
  },
  {
    id: 7,
    name: 'Inserts for Moulding',
    description: 'High-precision inserts for molding processes, offering superior durability and dimensional accuracy.',
    image: 'https://rajproducts.com/images/brass_inserts/brass_moulding_inserts/brass_moulding_inserts_3.jpg',
  },
  {
    id: 8,
    name: 'Eccentric Turning Components',
    description: 'Custom eccentric turning components designed to achieve offset machining for specialized applications.',
    image: 'https://cdn.canadianmetalworking.com/a/eccentric-turning-becoming-conventional-work-1518367327.jpg?size=1000x',
  },
  {
    id: 9,
    name: 'information is yet to be provided',
    description: 'information is yet to be provided',
    image: require('./assets/image1.png'),
  },
  {
    id: 10,
    name: 'information is yet to be provided',
    description: '',
    image: require('./assets/image2.png'),
  },
  {
    id: 11,
    name: 'information is yet to be provided',
    description: '',
    image: require('./assets/image3.png'),
  },
  {
    id: 12,
    name: 'information is yet to be provided',
    description: '',
    image: require('./assets/image4.png'),
  },
  {
    id: 13,
    name: 'information is yet to be provided',
    description: '',
    image: require('./assets/image5.png'),
  },
  {
    id: 14,
    name: 'information is yet to be provided',
    description: '',
    image: require('./assets/image6.png'),
  },
];

export default products;
